export default __webpack_public_path__ + "static/media/html.b585c428.svg";